import { CalendarEvent } from "toptaal-shared"

interface EventModalState {
  isEventModalOpen: boolean
  isAbsentConfirmModalOpen: boolean
  isRegisterModalOpen: boolean
  selectedEvent: CalendarEvent | null
}

type EventModalAction =
  | { type: "OPEN_EVENT_MODAL"; payload: CalendarEvent }
  | { type: "SET_SELECTED_EVENT"; payload: CalendarEvent }
  | { type: "CLOSE_EVENT_MODAL" }
  | { type: "OPEN_CONFIRM_MODAL" }
  | { type: "CLOSE_CONFIRM_MODAL" }
  | { type: "RESET" }
  | { type: "OPEN_REGISTER_MODAL" }
  | { type: "CLOSE_REGISTER_MODAL" }

export const initialState: EventModalState = {
  isEventModalOpen: false,
  isAbsentConfirmModalOpen: false,
  isRegisterModalOpen: false,
  selectedEvent: null,
}

export function eventModalReducer(
  state: EventModalState,
  action: EventModalAction,
): EventModalState {
  switch (action.type) {
    case "OPEN_EVENT_MODAL":
      return {
        ...state,
        isEventModalOpen: true,
        selectedEvent: action.payload,
        isRegisterModalOpen: false,
      }
    case "CLOSE_EVENT_MODAL":
      return {
        ...state,
        isEventModalOpen: false,
        isRegisterModalOpen: false,
      }
    case "OPEN_CONFIRM_MODAL":
      return {
        ...state,
        isEventModalOpen: false,
        isAbsentConfirmModalOpen: true,
        isRegisterModalOpen: false,
      }
    case "CLOSE_CONFIRM_MODAL":
      return {
        ...state,
        isAbsentConfirmModalOpen: false,
        isEventModalOpen: true,
        isRegisterModalOpen: false,
      }
    case "OPEN_REGISTER_MODAL":
      return {
        ...state,
        isRegisterModalOpen: true,
        isEventModalOpen: false,
      }
    case "CLOSE_REGISTER_MODAL":
      return {
        ...state,
        isRegisterModalOpen: false,
      }
    case "SET_SELECTED_EVENT":
      return {
        ...state,
        selectedEvent: action.payload,
      }
    case "RESET":
      return initialState
    default:
      return state
  }
}
